import * as React from 'react';

import { trackClickOffer } from './tracking';
import { Title } from '../../../components/OfferCard/Title';
import { useOfferContext } from '../../../context';
import {
  isCommercial,
  isGarage,
  isSuburban,
  getFloorCount,
  getFloorRange,
  getBuildingType,
} from '../../../utils/offers';
import { getOfferType } from '../../../utils/offers/getOfferType';

export const OfferTitleContainer = () => {
  const { offer, position } = useOfferContext();

  const { title, isCianPartner, externalUrl, fullUrl, category, floorNumber, offerType, building } = offer;

  const floorInfo = React.useMemo(() => {
    if (isSuburban(category)) {
      return getFloorCount(building ?? undefined);
    }
    if (!isGarage(category)) {
      return (
        getFloorRange(building ?? undefined, floorNumber ?? undefined) ||
        (isCommercial(offerType ?? undefined) ? getFloorCount(building ?? undefined) : '')
      );
    }

    return '';
  }, [building, category, floorNumber, offerType]);

  const commercialBuildingType = React.useMemo(() => {
    if (isCommercial(offerType ?? undefined) && building) {
      return getBuildingType(building);
    }

    return '';
  }, [building, offerType]);

  const secondTitle = React.useMemo(() => {
    const offerType = getOfferType(offer);

    return `${offerType}${commercialBuildingType ? `, ${commercialBuildingType}` : ''}${floorInfo ? `, ${floorInfo}` : ''}`;
  }, [commercialBuildingType, floorInfo, offer]);

  const href = isCianPartner ? externalUrl : fullUrl;

  const handleClick = React.useCallback(() => {
    trackClickOffer(offer.id ?? undefined, position);
  }, [offer.id, position]);

  return <Title mainTitle={title ?? undefined} secondTitle={secondTitle} onClick={handleClick} href={href as string} />;
};
